import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { toast } from 'react-toastify';

// import SignDeal from 'v3/pages/SignDeal';
import StartDeal from 'v3/pages/StartDeal';
import ReviewOffer from 'v3/pages/ReviewOffer';
import SignDeal from 'v3/pages/SignDeal';
import Welcome from 'v3/pages/Welcome';

type MapTypes = {
  [key: number]: JSX.Element;
};

export const StepsContent = () => {
  const { currentStep } = useSelector((state: RootState) => state.lead);

  useEffect(() => {
    if (currentStep) {
      const hideDiscountToast = () => toast.dismiss();
      hideDiscountToast();
    }
  }, [currentStep]);

  const mapForms: MapTypes = {
    0: <StartDeal />,
    1: <ReviewOffer />,
    2: <SignDeal />,
    3: <Welcome />,
  };

  return <>{mapForms[currentStep]}</>;
};
